export class FieldFactory {
  static getField(type, field) {
    if (field && field.domain && field.domain.domain_type == 'code-value') {
      return new SelectDomainField(field)
    }
    switch (type) {
      case 'array':
        return new ArrayField(field)
      case 'reference':
        return new ReferenceField(field)
      case 'region-field':
        return new RegionField(field)
      case 'geometry':
        return new GeometryField(field)
      case 'date':
        return new DateField(field)
      case 'select':
        return new SelectField(field)
      case 'number':
        return new NumberField(field)
      case 'double':
        return new DoubleNumberField(field)
      case 'file':
        return new FileField(field)
      case 'text':
        return new TextField(field)
      case 'string':
        return new StringField(field)
      default:
        return new AField(field)
    }
  }
}
export class AField {
  constructor(field = {}) {
    this._code = field.value || field.code
    this._domain = field.domain
    this._meta = Object.assign({ field: {} }, field.meta)
    this.setMeta()
  }
  get typeInput() {
    return 'v-text-field'
  }
  convertData(value) {
    return value + ''
  }
  defaultValue() {
    return this._meta.defaultValue || ''
  }
  formatShow(value) {
    return value
  }
  setMeta() {
    let meta = this._meta.field
    this.meta = meta
  }
}
export class ReferenceField extends AField {
  get typeInput() {
    return 'field-search-select'
  }
  setMeta() {
    let meta = this._meta.field
    this.meta = meta
  }
}
export class TextField extends AField {
  get typeInput() {
    return 'v-textarea'
  }
  setMeta() {
    let meta = this._meta.field
    if (meta.rows == null) meta.rows = 2
    if (meta['no-resize'] == null) meta['no-resize'] = true
    this.meta = meta
  }
}
export class StringField extends AField {
  get typeInput() {
    return 'v-text-field'
  }
  convertData(value) {
    return value + ''
  }
  defaultValue() {
    return this._meta.defaultValue || ''
  }

  setMeta() {
    let meta = this._meta.field
    this._meta.max = this._meta.max || 255
    meta.counter = this._meta.max
    if (!meta.rules) {
      meta.rules = []
    }
    meta.rules.push(
      (v) =>
        !v ||
        (!!v && v.length <= meta.counter) ||
        `Trường phải ít hơn ${meta.counter} ký tự`
    )
    this.meta = meta
  }
  formatShow(value) {
    return value
  }
}

export class SelectDomainField extends AField {
  get typeInput() {
    return 'v-select'
  }
  setMeta() {
    this.items = this._domain.metadata.items
    this.meta = { items: this._domain.metadata.items }
  }

  formatShow(value) {
    let result = this.items.find((x) => x == value || x.value == value)
    return result ? result.text || result : this.defaultValue()
  }
}
export class DateField extends AField {
  get typeInput() {
    return 'field-date-format'
  }

  setMeta() {
    this.meta = Object.assign({}, this._meta.field)
    this.meta.formatValue = 'YYYY-MM-DD'
  }
}
export class FileField extends AField {
  constructor(field = {}) {
    super(field)
    this._meta = Object.assign({ file: {} }, field.meta)
  }
  get typeInput() {
    return 'field-file-input'
  }
  get typeShow() {
    return 'file'
  }
  convertData(value) {
    return value
  }
  defaultValue() {
    return null
  }
  setMeta() {
    this.meta = Object.assign({}, this._meta.field, {
      accept: this._meta.file.accept,
      multiple: this._meta.file.multiple,
      title: '',
    })
  }
}
export class NumberField extends AField {
  get typeInput() {
    return 'field-number'
  }
  convertData(value) {
    return value
  }
  defaultValue() {
    return this._meta.defaultValue || 0
  }

  setMeta() {
    let meta = { step: 1, ...this._meta.field }
    if (this._domain && this._domain.domain_type == 'range') {
      if (this._domain.metadata.min != null) {
        meta.min = this._domain.metadata.min
      }
      if (this._domain.metadata.max != null) {
        meta.max = this._domain.metadata.max
      }
      if (this._domain.metadata.step != null) {
        meta.step = this._domain.metadata.step
      }
    }
    this.meta = meta
  }
}
export class DoubleNumberField extends AField {
  get typeInput() {
    return 'field-number'
  }
  convertData(value) {
    return value
  }
  defaultValue() {
    return this._meta.defaultValue || 0
  }

  setMeta() {
    let meta = { step: 'any', ...this._meta.field }
    if (this._domain && this._domain.domain_type == 'range') {
      if (this._domain.metadata.min != null) {
        meta.min = this._domain.metadata.min
      }
      if (this._domain.metadata.max != null) {
        meta.max = this._domain.metadata.max
      }
      if (this._domain.metadata.step != null) {
        meta.step = this._domain.metadata.step
      }
    }
    this.meta = meta
  }
}

export class SelectField extends AField {
  get typeInput() {
    return 'v-select'
  }
  convertData(value) {
    return value
  }
  defaultValue() {
    return null
  }

  setMeta() {
    let meta = { ...this._meta.field, items: this._meta.items }
    this.meta = meta
  }
  formatShow(value) {
    if (!this._meta || !this._meta.items) return value
    let result = this._meta.items.find((x) => x == value || x.value == value)
    return result ? result.text || result : this.defaultValue()
  }
}

export class GeometryField extends AField {
  get typeInput() {
    return 'field-geometry'
  }

  convertData(value) {
    return value
  }
  defaultValue() {
    return null
  }
}

export class RegionField extends AField {
  constructor(field = {}) {
    super(field)
    this._meta = Object.assign({ field: {} }, field.meta)
  }
  get typeShow() {
    return 'region'
  }
  get typeInput() {
    if (!this._meta.field.militaryOption) return 'field-region'
    return 'field-region-with-military'
  }
  convertData(value) {
    return value
  }
  defaultValue() {
    return {}
  }
}
export class ArrayField extends AField {
  get typeShow() {
    return 'array'
  }
}
